var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#3E3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2013 53.4708L61.45 61.4508M58.79 40.1708C58.79 50.4543 50.4536 58.7908 40.17 58.7908C29.8865 58.7908 21.55 50.4543 21.55 40.1708C21.55 29.8872 29.8865 21.5508 40.17 21.5508C50.4536 21.5508 58.79 29.8872 58.79 40.1708Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5e6b7a2361d97ae00d401a180ab5a9d2.svg";
export { ForwardRef as ReactComponent };